module.exports = __webpack_public_path__ + "static/media/burger.5a5877a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/assets/burger.svg
// module id = 1633
// module chunks = 0